import React from 'react';
import type { LinkProps as RouterLinkProps } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';

import type { ButtonProps } from '@mui/material';

import type { LookoButtonBaseProps } from '../LookoButtonBase';
import { LookoButtonBase } from '../LookoButtonBase';

type ButtonTypeProps =
  | {
      /**
       * 일반 버튼 형태.
       *
       * @default false
       */
      isAnchor?: false;

      /**
       * 클릭시 어떤 액션을 할 지
       */
      onClick?: ButtonProps['onClick'];
    }
  | ({
      /**
       * React Router 기반 링크 버튼.
       */
      isAnchor: true;
    } & RouterLinkProps);

type LookoButtonProps = ButtonProps & LookoButtonBaseProps & ButtonTypeProps;

/**
 * 버튼.
 */
export const LookoButton = React.forwardRef<HTMLButtonElement, LookoButtonProps>(
  ({ children, text, variant = 'contained', color = 'primary', ...props }, ref) => {
    if (props.isAnchor) {
      const { isAnchor, ...restProps } = props;

      return (
        <LookoButtonBase ref={ref} component={RouterLink} variant={variant} color={color} {...restProps}>
          {children ?? text}
        </LookoButtonBase>
      );
    } else {
      return (
        <LookoButtonBase ref={ref} variant={variant} color={color} {...props}>
          {children ?? text}
        </LookoButtonBase>
      );
    }
  },
);
